import BaseComponent from 'foundation/base-component';
import Scroller from '../../../general/js/scroller';

export default class SubNav extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.links = this.refs.links;

        this.init();
    }

    init() {
        if (this.element.classList.contains('sub-nav-light')) {
            this.links.forEach((link) => {
                this.addListener(link, 'click', this.onClick.bind(this));
            });
        }
    }

    onClick(event) {
        event.preventDefault();

        const elementId = event.target.getAttribute('href');
        const blockToShow = document.querySelector(elementId);

        if (blockToShow) {
            this.scroller = new Scroller(blockToShow, { scrollOffset: 100 });
            this.scroller.scrollToTop();
        }
    }

    onDestroy() {
        this.scroller = null;
    }
}
